import { combineReducers } from 'redux'

const initialLanguageReducerState = 'english'

function languageReducer(state=initialLanguageReducerState, action) {
    switch(action.type) {
        case 'CHANGELANGUAGE':
            return action.state
        default:
            return initialLanguageReducerState
    }
}

const initialCardViewReducerState = true

function cardViewReducer(state=initialCardViewReducerState, action) {
    switch(action.type) {
        case 'SHOWCARD':
            return true
        case 'HIDECARD':
            return false
        default:
            return state
    }
}

export default combineReducers({
    language: languageReducer,
    cardView: cardViewReducer,
})


// WEBPACK FOOTER //
// ./src/src/reducers.js